import { Link, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useCart } from "@/context/CartContext";
import { ShoppingBag, LogOut, User } from "lucide-react";
import { Button } from "@/components/ui/button";

const linkCls = ({ isActive }) =>
  `text-sm tracking-wide transition-colors ${isActive ? "text-[#002855] font-semibold" : "text-slate-700 hover:text-[#002855]"}`;

export default function Navbar() {
  const { user, logout } = useAuth();
  const { count } = useCart();
  const navigate = useNavigate();
  const authed = user && typeof user === "object";

  return (
    <header className="sticky top-0 z-40 backdrop-blur-xl bg-[#FDFBF7]/85 border-b border-slate-200/60">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3" data-testid="nav-logo">
          <div className="w-9 h-9 rounded-sm bg-[#002855] flex items-center justify-center text-[#C5A059] font-display text-xl leading-none">P</div>
          <div className="leading-tight">
            <div className="font-display text-[#0A192F] text-lg">PMF Foundation</div>
            <div className="label-eyebrow -mt-0.5">& Association</div>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          <NavLink to="/" end className={linkCls} data-testid="nav-home">Home</NavLink>
          <NavLink to="/history" className={linkCls} data-testid="nav-history">History</NavLink>
          <NavLink to="/store" className={linkCls} data-testid="nav-store">Store</NavLink>
          <NavLink to="/founders" className={linkCls} data-testid="nav-founders">Founders' Circle</NavLink>
          {authed && <NavLink to="/feed" className={linkCls} data-testid="nav-feed">Members Feed</NavLink>}
          {authed && <NavLink to="/groups" className={linkCls} data-testid="nav-groups">Groups</NavLink>}
          {authed && <NavLink to="/messages" className={linkCls} data-testid="nav-messages">Messages</NavLink>}
        </nav>

        <div className="flex items-center gap-3">
          <Link to="/cart" className="relative inline-flex items-center justify-center w-10 h-10 rounded-md border border-slate-200 bg-white hover:border-[#002855] transition-colors" data-testid="nav-cart">
            <ShoppingBag className="w-4 h-4 text-[#0A192F]" />
            {count > 0 && (
              <span className="absolute -top-1.5 -right-1.5 bg-[#9B111E] text-white text-[10px] font-semibold w-5 h-5 rounded-full flex items-center justify-center" data-testid="cart-count">{count}</span>
            )}
          </Link>
          {authed ? (
            <>
              <Link to="/profile" className="hidden sm:inline-flex items-center gap-2 px-3 h-10 rounded-md border border-slate-200 bg-white hover:border-[#002855] transition-colors" data-testid="nav-profile">
                <User className="w-4 h-4 text-[#0A192F]" />
                <span className="text-sm">{user.name?.split(" ")[0]}</span>
              </Link>
              <Button variant="ghost" onClick={() => { logout(); navigate("/"); }} data-testid="nav-logout" className="text-sm">
                <LogOut className="w-4 h-4" />
              </Button>
            </>
          ) : (
            <>
              <Link to="/login" className="text-sm text-[#0A192F] hover:text-[#002855] hidden sm:inline" data-testid="nav-login">Sign in</Link>
              <Link to="/register" data-testid="nav-register">
                <Button className="bg-[#002855] text-white hover:bg-[#0A192F] rounded-md">Become a member</Button>
              </Link>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
